module.exports = __webpack_public_path__ + "img/musical-note-white.c71cfb8a.svg";